
    export function byteFilter(bytes: number, precision: number): string {
        if (bytes === 0) { return '0 bytes' }
        if (isNaN(bytes) || !isFinite(bytes)) return '-';
        if (typeof precision === 'undefined') precision = 1;
        var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
        var total = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, Math.floor(total))).toFixed(precision) + ' ' + units[total];
    }